import { useEffect } from "react";
import { Box } from "@mui/material";
import { useAuth, RTLoginSSOFlow } from "@videostream/route-this-login-react";
import formStyles from "../styles/Login.module.scss";

function Login() {
  const ssoProviderDetails = {
    microsoftClientId: process.env.NEXT_PUBLIC_MICROSOFT_CLIENT_ID ?? '',
    googleClientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? '',
    oktaClientId: process.env.NEXT_PUBLIC_OKTA_CLIENT_ID ?? '',
    oktaBaseURL: process.env.NEXT_PUBLIC_OKTA_BASE_URL ?? '',
    redirectURL: process.env.NEXT_PUBLIC_REDIRECT_URL ?? '',
    requireCode: process.env.NEXT_PUBLIC_REQUIRE_CODE === 'true',
    ssoLoginURL: process.env.NEXT_PUBLIC_SSO_LOGIN_URL ?? '',
    postLoginRedirect: process.env.NEXT_PUBLIC_POST_LOGIN_REDIRECT ?? '',
  };

  const { currentUser } = useAuth();
  useEffect(() => {
    // when page first loads check if user already signed in
    if (currentUser && currentUser.email) {
      window.location.href = '/';
    }
  }, [currentUser]);

  async function completeLogin() {
    window.location.href = '/';
  }

  return (
     <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className={formStyles.loginFormContainer}
      >
        {/* Note: The locale set in RTLoginSSOFlow doesn't matter since setting the 
        locale here doesn't work (as of writing this).The locale is actually set in the 
        RTAuthWrapper in app.tsx.} */}
        <RTLoginSSOFlow
          showSSO={process.env.NEXT_PUBLIC_SHOW_SSO === 'true'}
          ssoDetails={ssoProviderDetails}
          apiUrl={process.env.NEXT_PUBLIC_AUTH_API_URL}
          locale='en' 
          onLoginCompleteCallback={completeLogin}
        />
      </Box>
  );

}


Login.hideNav = true;

export default Login;
